import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-back",
  "use": "svg_i-back-usage",
  "viewBox": "0 0 19 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 20\" id=\"svg_i-back\"><path d=\"M0 0v14.765h4.75v4.921H19V4.921h-4.75V0H0Zm6.786 17.576h10.179V7.03H6.785v10.546Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol